var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FileUploader',{attrs:{"text":'Прикачване на файл',"allowedFiles":'image/jpeg, image/png, application/pdf'},on:{"file-upload":_vm.uploadFile}})}
var staticRenderFns = []

export { render, staticRenderFns }